/* eslint-disable */
export default function init(Blockly, profile, img_path) {
  Blockly.Blocks.neopixel = {};
  Blockly.Blocks.neopixel.style = "neopixel_blocks";
  Blockly.Blocks.neopixel_init = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.appendDummyInput().appendField(Blockly.Msg.NEOPIXEL);
      this.setStyle(Blockly.Blocks.neopixel.style);
      this.appendDummyInput("")
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/neopixel2.svg", 30, 30)
        )
        .appendField(Blockly.Msg.NEOPIXEL_INIT)
        .appendField(
          new Blockly.FieldDropdown([
            ["GRB", "NEO_GRB"],
            ["RBG", "NEO_RBG"],
            ["NRGB", "NEO_RGB"],
          ]),
          "RGBMODE"
        )
        .appendField(
          new Blockly.FieldDropdown([
            ["800\u007fKHz", "NEO_KHZ800"],
            ["400\u007fKHz", "NEO_KHZ400"],
          ]),
          "FREQ"
        );
      this.appendValueInput("LEDCOUNT", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(Blockly.Msg.NEOPIXEL_LEDCOUNT);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.NEOPIXEL_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].digital),
          "PIN"
        );
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.neopixel_clear = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.appendDummyInput().appendField(Blockly.Msg.NEOPIXEL);
      this.setStyle(Blockly.Blocks.neopixel.style);
      this.appendDummyInput("")
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/neopixel2.svg", 30, 30)
        )
        .appendField(Blockly.Msg.NEOPIXEL_CLEAR);
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.neopixel_setled = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.appendDummyInput().appendField(Blockly.Msg.NEOPIXEL)
      this.setStyle(Blockly.Blocks.neopixel.style);
      this.appendDummyInput("").appendField(
        new Blockly.FieldImage(img_path + "arduino/neopixel2.svg", 30, 30)
      );
      this.appendValueInput("LEDNUMBER", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(Blockly.Msg.NEOPIXEL_SETPIXEL);
      this.appendValueInput("R", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField("R");
      this.appendValueInput("G", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField("G");
      this.appendValueInput("B", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField("B");
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.neopixel_setledxy = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.appendDummyInput().appendField(Blockly.Msg.NEOPIXEL);
      this.setStyle(Blockly.Blocks.neopixel.style);
      this.appendDummyInput("")
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/neopixel2.svg", 30, 30)
        )
        .appendField(Blockly.Msg.NEOPIXEL_SETMATRIX)
        .appendField(
          new Blockly.FieldDropdown([
            ["8x8", "8x8"],
            ["16x16", "16x16"],
            ["8x5", "8x5"],
            ["32x32", "32x32"],
            ["32x48", "32x48"],
          ]),
          "MATRIXSIZE"
        );
      this.appendValueInput("X", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField("X");
      this.appendValueInput("Y", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField("Y");
      this.appendValueInput("R", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField("R");
      this.appendValueInput("G", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField("G");
      this.appendValueInput("B", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField("B");
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.neopixel_setled_colour_picker = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.appendDummyInput().appendField(Blockly.Msg.NEOPIXEL);
      this.setStyle(Blockly.Blocks.neopixel.style);
      this.appendDummyInput("").appendField(
        new Blockly.FieldImage(img_path + "arduino/neopixel2.svg", 30, 30)
      );
      this.appendValueInput("LEDNUMBER", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(Blockly.Msg.NEOPIXEL_SETPIXEL);
      this.appendDummyInput("").appendField(Blockly.Msg.NEOPIXEL_COLOUR);
      this.appendValueInput("COLOUR", new Blockly.FieldColour("#ff0000"));

      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.neopixel_show = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.appendDummyInput().appendField(Blockly.Msg.NEOPIXEL);
      this.setStyle(Blockly.Blocks.neopixel.style);
      this.appendDummyInput("")
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/neopixel2.svg", 30, 30)
        )
        .appendField(Blockly.Msg.NEOPIXEL_SHOW);
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.neopixel_examples = {
    helpUrl: "",
    shopUrl: "",
    validate: function(newValue) {
      this.getSourceBlock().updateConnections(newValue);
      return newValue;
    },
    init: function () {
      this.setStyle(Blockly.Blocks.neopixel.style);
      this.appendDummyInput()
          .appendField(Blockly.Msg.NEOPIXEL)
          .appendField(
            new Blockly.FieldImage(img_path + "arduino/neopixel2.svg", 30, 30)
          )
          .appendField(Blockly.Msg.NEOPIXEL_EXAMPLES)
          .appendField(
            new Blockly.FieldDropdown([
              [Blockly.Msg.NEOPIXEL_RAINBOW, "NEO_EXAMPLE_RAINBOW"], // speed           Rainbow
              [Blockly.Msg.NEOPIXEL_THEATER, "NEO_EXAMPLE_THEATER"], // speed           Theater
              [Blockly.Msg.NEOPIXEL_WIPE,    "NEO_EXAMPLE_WIPE"],    // color and speed Wipe
              [Blockly.Msg.NEOPIXEL_CHASE,   "NEO_EXAMPLE_CHASE"],   // color and speed Flash
            ], this.validate),
            "EXAMPLE"
          );
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
    },
    updateConnections: function(newValue) {
      this.removeInput('SPEED', /* no error */ true);
      this.removeInput('SPEED_UNITS', /* no error */ true);
      this.removeInput('COLOUR', /* no error */ true);
      this.removeInput('R', /* no error */ true);
      this.removeInput('G', /* no error */ true);
      this.removeInput('B', /* no error */ true);

      this.appendDummyInput('SPEED')
          .setAlign(Blockly.ALIGN_RIGHT)
          .appendField(Blockly.Msg.NEOPIXEL_SPEED)
          .appendField(new Blockly.FieldNumber(20, 1, 1000, 1), 'SPEED_NUMBER');

      this.appendDummyInput('SPEED_UNITS')
          .appendField(Blockly.Msg.NEOPIXEL_UNITS);

      if ((newValue == 'NEO_EXAMPLE_WIPE')  ||
          (newValue == 'NEO_EXAMPLE_CHASE')) {

            this.appendDummyInput('COLOUR')
            .appendField(Blockly.Msg.NEOPIXEL_COLOUR);

            this.appendValueInput("R", "Number")
            .setCheck("Number")
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(Blockly.Msg.NEOPIXEL_RED);

            this.appendValueInput("G", "Number")
            .setCheck("Number")
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(Blockly.Msg.NEOPIXEL_GREEN);

            this.appendValueInput("B", "Number")
            .setCheck("Number")
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(Blockly.Msg.NEOPIXEL_BLUE);
        }
    }
  };
  Blockly.Blocks.neopixel_setbrightness = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.appendDummyInput().appendField(Blockly.Msg.NEOPIXEL);
      this.setStyle(Blockly.Blocks.neopixel.style);
      this.appendDummyInput("").appendField(
        new Blockly.FieldImage(img_path + "arduino/neopixel2.svg", 30, 30)
      );
      this.appendValueInput("BRIGHTNESS", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(Blockly.Msg.NEOPIXEL_BRIGHTNESS);
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
    },
  };
}
